import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  min-height: 100vh;
  background-color: #f8fafc;
`

const MainContent = styled.main`
  min-height: calc(100vh - 64px);
  padding: 1rem;
  
  @media (min-width: 640px) {
    padding: 1.5rem;
  }
  
  @media (min-width: 1024px) {
    padding: 2rem;
  }
`

const ContentWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
`

function ResponsiveLayout({ children }) {
  return (
    <Container>
      <MainContent>
        <ContentWrapper>
          {children}
        </ContentWrapper>
      </MainContent>
    </Container>
  )
}

export default ResponsiveLayout
